import React from "react";

const Field = ({ label, value }) => {
  const displayValue =
    value === undefined || value === null || value === "" ? "—" : value;
  return (
    <div className="flex justify-between text-sm">
      <span className="bw-muted font-medium">{label}</span>
      <span className="text-right text-white italic">{displayValue}</span>
    </div>
  );
};

const UserProfile = ({ profile, loading }) => {
  if (loading && !profile) {
    return (
      <section className="bw-card p-4">
        <p className="text-sm bw-muted">Loading profile...</p>
      </section>
    );
  }

  if (!profile) {
    return null;
  }

  return (
    <section className="bw-card p-6">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-white">Profile</h2>
        <p className="text-sm bw-muted">
          Telegram ID:{" "}
          <span className="italic text-white/90">{profile.telegramId}</span>
        </p>
      </div>

      <div className="space-y-4">
        <Field label="Name" value={profile.name} />
        <Field
          label="Username"
          value={profile.telegramUsername ? `${profile.telegramUsername}` : ""}
        />
        <Field label="Phone" value={profile.phoneNumber} />
        <Field label="Home Address" value={profile.homeAddress} />
        <Field label="Work Address" value={profile.workAddress} />
        <Field
          label="Rating"
          value={
            profile.rating?.toFixed
              ? profile.rating.toFixed(1)
              : profile.rating
          }
        />
      </div>

      <div className="mt-6 grid grid-cols-3 gap-3 text-center">
        <div className="bw-card p-3">
          <p className="text-xs tracking-wide bw-muted">Total Rides</p>
          <p className="mt-1 text-lg font-semibold text-white">
            {profile.totalRides}
          </p>
        </div>
        <div className="bw-card p-3">
          <p className="text-xs tracking-wide bw-muted">Completed</p>
          <p className="mt-1 text-lg font-semibold text-white">
            {profile.completedRides}
          </p>
        </div>
        <div className="bw-card p-3">
          <p className="text-xs tracking-wide bw-muted">Success</p>
          <p className="mt-1 text-lg font-semibold text-white">
            {profile.successRate}%
          </p>
        </div>
      </div>
    </section>
  );
};

export default UserProfile;
